<!-- Absolutely positioned buttons: Desktop OR Mobile/Tablet non-scrolling -->
@if (isDesktop || !isScrolling) {
  <div class="absolute-navigation">
    @if (showBackButton) {
      <evs-button
        (click)="onBackClick()"
        class="absoluteBackButton"
        [buttonData]="{
          type: 'navigationButton',
          iconName: 'ArrowLeft',
          active: true,
          iconColor: getButtonIconColor(),
          backgroundColor: getButtonBackgroundColor(),
        }">
      </evs-button>
    }

    @if (showCloseButton) {
      <evs-button
        (click)="onCloseClick()"
        class="absoluteCloseButton"
        [buttonData]="{
          type: 'navigationButton',
          iconName: 'Times',
          active: true,
          iconColor: getButtonIconColor(),
          backgroundColor: getButtonBackgroundColor(),
        }">
      </evs-button>
    }
  </div>
}

<!-- Mobile/Tablet: Sticky navigation when scrolling -->
@if (!isDesktop && isScrolling) {
  <div class="topInfo">
    <div class="stickyStep">
      @if (showBackButton) {
        <evs-button
          (click)="onBackClick()"
          class="returnButton"
          [buttonData]="{
            type: 'navigationButton',
            iconName: 'ArrowLeft',
            active: true,
            iconColor: getButtonIconColor(),
            backgroundColor: getButtonBackgroundColor(),
          }">
        </evs-button>
      }

      <!-- Sticky H1 title -->
      @if (stickyTitle) {
        <div class="sticky-h1">
          <evs-text [rawText]="stickyTitle" type="heading16"></evs-text>
        </div>
      }

      @if (showCloseButton) {
        <evs-button
          (click)="onCloseClick()"
          class="closeButton"
          [buttonData]="{
            type: 'navigationButton',
            iconName: 'Times',
            active: true,
            iconColor: getButtonIconColor(),
            backgroundColor: getButtonBackgroundColor(),
          }">
        </evs-button>
      }
    </div>

    <!-- Progress bar - XS only -->
    @if (showProgressBar) {
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div class="progress-segments">
            @for (segment of getProgressSegments(); track segment) {
              <div class="segment" [class.filled]="segment.filled"></div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
